module.exports = __webpack_public_path__ + "static/media/how_it_works.c036e9ce.svg";